import type { ParticipantStatus, SampleStatus, ShipmentStatus, WithdrawalScope } from '../../types';

export const PARTICIPANT_STATUS_LABEL: Record<ParticipantStatus, string> = {
  SCREENING: 'Screening',
  INKLUDERT: 'Inkludert',
  UTTRUKKET: 'Uttrukket',
  FULLFORT: 'Fullført',
};

export const PARTICIPANT_STATUS_TONE: Record<ParticipantStatus, 'info' | 'ok' | 'down' | 'unknown'> = {
  SCREENING: 'info',
  INKLUDERT: 'ok',
  UTTRUKKET: 'down',
  FULLFORT: 'unknown',
};

export const SAMPLE_STATUS_LABEL: Record<SampleStatus, string> = {
  STORED: 'Lagret',
  SHIPPED: 'Sendt',
  ANALYZED: 'Analysert',
  DESTROYED: 'Destruert',
};

export const SHIPMENT_STATUS_LABEL: Record<ShipmentStatus, string> = {
  PREPARING: 'Forberedes',
  SENT: 'Sendt',
  RECEIVED: 'Mottatt',
  IDAT_RECEIVED: 'IDAT mottatt',
};

export const WITHDRAWAL_SCOPE_LABEL: Record<WithdrawalScope, string> = {
  FULL: 'Fullt tilbaketrukket',
  FREMTIDIG_BRUK: 'Fremtidig bruk',
  KUN_BIOBANK: 'Kun biobank',
};
